const SENTRY_ENVIRONMENTS = {
  Local: 'local development',
  Development: 'dev',
  Staging: 'staging',
  Testing: 'jest test',
  Production: 'production',
};

export default SENTRY_ENVIRONMENTS;
